/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonCloudflareTurnstileSiteVerifyInfo = {
    SCS?: BabylonCloudflareTurnstileSiteVerifyInfo.SCS;
    CHALTS?: string;
    HOSTNM?: string;
    ACTN?: string;
    CDATA?: string;
    MTDATA?: Record<string, string>;
};

export namespace BabylonCloudflareTurnstileSiteVerifyInfo {

    export enum SCS {
        Y = 'Y',
        N = 'N',
    }


}

